import { withRouter } from 'react-router-dom'
import React from 'react'
import { withProps } from 'recompose'

import {
  getTrack,
  getWorkshopsContent,
  getLecturesContent,
} from '../app/selectors'
import ScheduleTable from './ScheduleTable'
import content from '../content'
import { isTrackWorkshop } from '../app/predicates'

const TrackPage = ({ track, programContent }) => {
  if (!track) {
    return null
  }
  return (
    <div>
      <h1>{track.label}</h1>
      <ScheduleTable tracks={[track]} programContent={programContent} />
    </div>
  )
}

const withPageContent = withProps(ownProps => {
  const track = getTrack(content, ownProps.match.params.id)
  return {
    track,
    programContent: isTrackWorkshop(track)
      ? getWorkshopsContent(content)
      : getLecturesContent(content),
  }
})

export default withPageContent(withRouter(TrackPage))



// WEBPACK FOOTER //
// ./src/containers/TrackPage.js